var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeotreeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 47,
    viewBox: "0 0 194 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2733_8313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8602 11.8783H75.7588V28.5895C75.7192 35.1441 71.2767 39.3563 64.6329 39.3563C61.9357 39.3563 58.7229 38.7068 56.4818 37.7423V33.6875C58.4452 34.7307 61.5787 35.4196 64.1966 35.4196C68.1036 35.4196 70.6421 33.1954 70.8404 29.3375C69.3332 30.8334 66.8938 31.7979 64.3156 31.7979C59.06 31.7979 54.6572 27.9596 54.6572 21.6807C54.6572 15.4017 59.06 11.4453 64.3156 11.4453C66.9334 11.4453 69.3332 12.4885 70.8404 13.9648V11.8783H70.8602ZM65.4262 27.7234C67.3103 27.7234 69.4323 26.7983 70.8602 25.3811V17.8818C69.4323 16.4646 67.3103 15.5394 65.4262 15.5394C62.3323 15.5394 59.6748 17.8424 59.6351 21.6216C59.6748 25.4402 62.3323 27.7234 65.4262 27.7234Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2014 21.1927C99.2014 21.6061 99.1617 22.1178 99.1221 22.4131H84.8031C85.2196 25.9364 87.6193 27.9244 91.1296 27.9244C93.212 27.9244 96.0282 27.2749 97.9916 26.3891V30.2274C96.3654 31.1131 93.3112 31.8808 90.5347 31.8808C83.8512 31.8808 80.083 27.393 80.083 21.5076C80.083 15.1893 84.3668 11.4298 90.0388 11.4298C95.9687 11.4101 99.2411 15.5239 99.2014 21.1927ZM85.0411 19.2637H94.5408C94.1838 16.8033 92.6171 15.3271 90.0587 15.3271C87.54 15.3271 85.6559 16.823 85.0411 19.2637Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.097 21.6455C102.097 15.6618 106.837 11.4102 112.786 11.4102C118.736 11.4102 123.476 15.6618 123.476 21.6455C123.476 27.5899 118.736 31.8808 112.786 31.8808C106.837 31.8808 102.097 27.5899 102.097 21.6455ZM118.577 21.6455C118.577 18.2403 115.959 15.7011 112.786 15.7011C109.653 15.7011 107.035 18.2206 107.035 21.6455C107.035 25.0704 109.653 27.5899 112.786 27.5899C115.959 27.5899 118.577 25.0507 118.577 21.6455Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.766 30.5393V31.5825C137.913 31.7794 136.961 31.8975 136.029 31.8975C130.733 31.8975 128.492 28.3348 128.492 23.6304V6.62403L129.425 5.73828H129.663V11.8598H138.508V12.9227H129.663V23.4927C129.663 26.2877 130.436 30.7755 136.267 30.7755C137.139 30.7952 137.992 30.6771 138.766 30.5393Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.358 11.4495V12.4927H150.902C148.582 12.4927 145.924 13.8706 144.179 15.8586V31.4084H143.029V11.8826H144.179V14.5595C145.924 12.7683 148.622 11.4102 150.942 11.4102C151.081 11.4102 151.279 11.4102 151.358 11.4495Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.214 20.7598V21.4487C154.214 27.0781 157.725 30.7983 162.703 30.7983C164.785 30.7983 167.403 30.1487 169.505 29.0661V30.2078C167.76 31.2116 164.983 31.8612 162.703 31.8612C156.832 31.8612 153.044 27.7277 153.044 21.488C153.044 15.2878 156.872 11.4102 162.187 11.4102C167.442 11.4102 170.556 15.209 170.556 20.3661C170.556 20.5629 170.556 20.7204 170.516 20.7401H154.214V20.7598ZM154.313 19.7362H169.406C169.168 15.4846 166.51 12.4927 162.187 12.4927C158.022 12.4927 154.948 15.209 154.313 19.7362Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.714 20.7598V21.4487C175.714 27.0781 179.224 30.7983 184.202 30.7983C186.284 30.7983 188.902 30.1487 191.005 29.0661V30.2078C189.259 31.2116 186.483 31.8612 184.202 31.8612C178.332 31.8612 174.544 27.7277 174.544 21.488C174.544 15.2878 178.371 11.4102 183.686 11.4102C188.942 11.4102 192.056 15.209 192.056 20.3661C192.056 20.5629 192.056 20.7204 192.016 20.7401H175.714V20.7598ZM175.833 19.7362H190.925C190.687 15.4846 188.03 12.4927 183.706 12.4927C179.522 12.4927 176.448 15.209 175.833 19.7362Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9614 43.1048V37.6328H94.6983V38.243H92.6754V39.9751H94.5793V40.5853H92.6754V42.4946H94.8371L94.738 43.1048H91.9614Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6641 43.1048L96.7206 38.7744V43.1048H96.0859V37.6328H96.8197L98.7633 41.9632V37.6328H99.3979V43.1048H98.6641Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.036 43.1048L100.489 37.6328H101.263L102.413 42.1797L103.583 37.6328H104.317L102.77 43.1048H102.036Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.407 43.1048V37.6328H106.101V43.1048H105.407Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.267 43.1007L109.334 40.7978C109.235 40.8175 109.116 40.8371 108.958 40.8371H108.422V43.1204H107.728V37.6484H108.977C109.553 37.6484 110.009 37.7862 110.306 38.0421C110.604 38.298 110.762 38.6917 110.762 39.1837C110.762 39.4987 110.703 39.7939 110.564 40.0301C110.425 40.2663 110.227 40.4632 109.989 40.6009L111.02 43.1007H110.267ZM108.918 40.227C109.315 40.227 109.612 40.1482 109.791 39.9908C109.969 39.8333 110.068 39.5577 110.068 39.2034C110.068 38.8688 109.969 38.6326 109.791 38.4751C109.612 38.3177 109.315 38.2389 108.918 38.2389H108.422V40.2466H108.918V40.227Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.974 43.2436C113.32 43.2436 112.844 43.0074 112.507 42.5153C112.169 42.0233 112.011 41.3147 112.011 40.3699C112.011 39.4251 112.189 38.7165 112.526 38.2244C112.864 37.7323 113.359 37.4961 114.014 37.4961C114.668 37.4961 115.144 37.7323 115.481 38.2244C115.819 38.7165 115.977 39.4251 115.977 40.3502C115.977 41.295 115.819 42.0036 115.481 42.4957C115.124 43.0074 114.629 43.2436 113.974 43.2436ZM113.994 42.6334C114.43 42.6334 114.728 42.4563 114.946 42.0823C115.144 41.7083 115.243 41.1375 115.243 40.3699C115.243 39.6022 115.144 39.0314 114.946 38.6574C114.748 38.2834 114.43 38.1063 113.994 38.1063C113.558 38.1063 113.26 38.2834 113.062 38.6574C112.864 39.0314 112.764 39.6022 112.764 40.3699C112.764 41.1375 112.864 41.7083 113.062 42.0823C113.26 42.4563 113.577 42.6334 113.994 42.6334Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.965 43.1048L118.022 38.7744V43.1048H117.387V37.6328H118.121L120.065 41.9632V37.6328H120.699V43.1048H119.965Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.072 43.1048V38.8532L124.783 43.1048H124.208L122.938 38.8729V43.1048H122.323V37.6328H123.196L124.525 42.16L125.854 37.6328H126.687V43.1048H126.072Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.335 43.1048V37.6328H131.072V38.243H129.049V39.9751H130.953V40.5853H129.049V42.4946H131.211L131.112 43.1048H128.335Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.038 43.1048L133.094 38.7744V43.1048H132.46V37.6328H133.194L135.137 41.9632V37.6328H135.772V43.1048H135.038Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.249 43.1048V38.243H136.9V37.6328H140.292V38.243H138.943V43.1048H138.249Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.882 43.1048L143.465 41.6088H141.72L141.304 43.1048H140.61L142.236 37.6328H142.97L144.596 43.1048H143.882ZM142.593 38.4005L141.879 41.0183H143.307L142.593 38.4005Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.707 43.1048V37.6328H146.401V42.4946H148.484L148.384 43.1048H145.707Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.148 43.1048V38.8532L153.859 43.1048H153.284L152.014 38.8729V43.1048H151.4V37.6328H152.272L153.601 42.16L154.93 37.6328H155.763V43.1048H155.148Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.155 43.2436C158.5 43.2436 158.024 43.0074 157.687 42.5153C157.35 42.0233 157.191 41.3147 157.191 40.3699C157.191 39.4251 157.37 38.7165 157.707 38.2244C158.044 37.7323 158.54 37.4961 159.194 37.4961C159.849 37.4961 160.325 37.7323 160.662 38.2244C160.999 38.7165 161.158 39.4251 161.158 40.3502C161.158 41.295 160.979 42.0036 160.642 42.4957C160.285 43.0074 159.789 43.2436 159.155 43.2436ZM159.155 42.6334C159.591 42.6334 159.888 42.4563 160.087 42.0823C160.285 41.7083 160.384 41.1375 160.384 40.3699C160.384 39.6022 160.285 39.0314 160.087 38.6574C159.888 38.2834 159.571 38.1063 159.155 38.1063C158.718 38.1063 158.421 38.2834 158.222 38.6574C158.024 39.0314 157.925 39.6022 157.925 40.3699C157.925 41.1375 158.024 41.7083 158.222 42.0823C158.421 42.4563 158.738 42.6334 159.155 42.6334Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.143 43.1048L163.199 38.7744V43.1048H162.564V37.6328H163.298L165.242 41.9632V37.6328H165.876V43.1048H165.143Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.482 43.1048V37.6328H168.177V43.1048H167.482Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.675 43.1048V38.243H169.326V37.6328H172.718V38.243H171.369V43.1048H170.675Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.396 43.2436C174.741 43.2436 174.265 43.0074 173.928 42.5153C173.591 42.0233 173.432 41.3147 173.432 40.3699C173.432 39.4251 173.611 38.7165 173.948 38.2244C174.285 37.7323 174.781 37.4961 175.435 37.4961C176.09 37.4961 176.566 37.7323 176.903 38.2244C177.24 38.7165 177.399 39.4251 177.399 40.3502C177.399 41.295 177.22 42.0036 176.883 42.4957C176.546 43.0074 176.05 43.2436 175.396 43.2436ZM175.415 42.6334C175.852 42.6334 176.149 42.4563 176.347 42.0823C176.546 41.7083 176.645 41.1375 176.645 40.3699C176.645 39.6022 176.546 39.0314 176.347 38.6574C176.149 38.2834 175.832 38.1063 175.415 38.1063C174.979 38.1063 174.682 38.2834 174.483 38.6574C174.285 39.0314 174.186 39.6022 174.186 40.3699C174.186 41.1375 174.285 41.7083 174.483 42.0823C174.682 42.4563 174.999 42.6334 175.415 42.6334Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.345 43.1007L180.413 40.7978C180.314 40.8175 180.195 40.8371 180.036 40.8371H179.481V43.1204H178.787V37.6484H180.036C180.611 37.6484 181.068 37.7862 181.365 38.0421C181.663 38.298 181.821 38.6917 181.821 39.1837C181.821 39.4987 181.762 39.7939 181.623 40.0301C181.484 40.2663 181.286 40.4632 181.048 40.6009L182.079 43.1007H181.345ZM179.997 40.227C180.393 40.227 180.691 40.1482 180.869 39.9908C181.048 39.8333 181.147 39.5577 181.147 39.2034C181.147 38.8688 181.048 38.6326 180.869 38.4751C180.691 38.3177 180.393 38.2389 179.997 38.2389H179.481V40.2466H179.997V40.227Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.308 43.1048V37.6328H184.002V43.1048H183.308Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.207 43.1048L186.264 38.7744V43.1048H185.629V37.6328H186.363L188.306 41.9632V37.6328H188.941V43.1048H188.207Z",
    fill: "#051A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.323 40.9208H192.332V40.3107H193.998V42.6727C193.74 42.8892 193.482 43.027 193.204 43.1254C192.946 43.2238 192.649 43.2632 192.332 43.2632C191.677 43.2632 191.181 43.027 190.844 42.5349C190.507 42.0428 190.348 41.3342 190.348 40.3894C190.348 39.4446 190.507 38.736 190.844 38.2439C191.181 37.7518 191.657 37.5156 192.312 37.5156C193.224 37.5156 193.779 38.0274 193.978 39.0706L193.284 39.1887C193.204 38.8147 193.085 38.5588 192.927 38.3817C192.768 38.2045 192.55 38.1258 192.292 38.1258C191.875 38.1258 191.578 38.303 191.38 38.6769C191.181 39.0312 191.082 39.6021 191.082 40.3894C191.082 41.1767 191.181 41.7475 191.4 42.1018C191.618 42.4561 191.935 42.653 192.391 42.653C192.768 42.653 193.085 42.5546 193.323 42.3774V40.9208Z",
    fill: "#051A16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 23.6708C14.4054 23.6708 14.7161 23.3624 14.7161 22.9819C14.7161 22.6014 14.4054 22.293 14.022 22.293C13.6387 22.293 13.3279 22.6014 13.3279 22.9819C13.3279 23.3624 13.6387 23.6708 14.022 23.6708Z",
    fill: "url(#paint0_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27905 23.5716C7.60765 23.5716 7.87402 23.3073 7.87402 22.9811C7.87402 22.655 7.60765 22.3906 7.27905 22.3906C6.95046 22.3906 6.68408 22.655 6.68408 22.9811C6.68408 23.3073 6.95046 23.5716 7.27905 23.5716Z",
    fill: "url(#paint1_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2225 4.32102C23.5292 4.32102 23.7778 4.07427 23.7778 3.76988C23.7778 3.4655 23.5292 3.21875 23.2225 3.21875C22.9159 3.21875 22.6672 3.4655 22.6672 3.76988C22.6672 4.07427 22.9159 4.32102 23.2225 4.32102Z",
    fill: "url(#paint2_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5856 4.51633C20.8923 4.51633 21.1409 4.26958 21.1409 3.9652C21.1409 3.66081 20.8923 3.41406 20.5856 3.41406C20.2789 3.41406 20.0303 3.66081 20.0303 3.9652C20.0303 4.26958 20.2789 4.51633 20.5856 4.51633Z",
    fill: "url(#paint3_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0072 5.05149C18.3139 5.05149 18.5625 4.80474 18.5625 4.50035C18.5625 4.19597 18.3139 3.94922 18.0072 3.94922C17.7005 3.94922 17.4519 4.19597 17.4519 4.50035C17.4519 4.80474 17.7005 5.05149 18.0072 5.05149Z",
    fill: "url(#paint4_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5282 5.91867C15.8349 5.91867 16.0835 5.67192 16.0835 5.36754C16.0835 5.06316 15.8349 4.81641 15.5282 4.81641C15.2215 4.81641 14.9729 5.06316 14.9729 5.36754C14.9729 5.67192 15.2215 5.91867 15.5282 5.91867Z",
    fill: "url(#paint5_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1886 7.10617C13.4953 7.10617 13.7439 6.85942 13.7439 6.55504C13.7439 6.25066 13.4953 6.00391 13.1886 6.00391C12.8819 6.00391 12.6333 6.25066 12.6333 6.55504C12.6333 6.85942 12.8819 7.10617 13.1886 7.10617Z",
    fill: "url(#paint6_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0258 8.62571C11.3325 8.62571 11.5811 8.37895 11.5811 8.07457C11.5811 7.77019 11.3325 7.52344 11.0258 7.52344C10.7191 7.52344 10.4705 7.77019 10.4705 8.07457C10.4705 8.37895 10.7191 8.62571 11.0258 8.62571Z",
    fill: "url(#paint7_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10145 10.4148C9.40814 10.4148 9.65675 10.168 9.65675 9.86363C9.65675 9.55925 9.40814 9.3125 9.10145 9.3125C8.79476 9.3125 8.54614 9.55925 8.54614 9.86363C8.54614 10.168 8.79476 10.4148 9.10145 10.4148Z",
    fill: "url(#paint8_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43421 12.4538C7.7409 12.4538 7.98952 12.2071 7.98952 11.9027C7.98952 11.5983 7.7409 11.3516 7.43421 11.3516C7.12752 11.3516 6.87891 11.5983 6.87891 11.9027C6.87891 12.2071 7.12752 12.4538 7.43421 12.4538Z",
    fill: "url(#paint9_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06751 14.6999C6.3742 14.6999 6.62282 14.4532 6.62282 14.1488C6.62282 13.8444 6.3742 13.5977 6.06751 13.5977C5.76083 13.5977 5.51221 13.8444 5.51221 14.1488C5.51221 14.4532 5.76083 14.6999 6.06751 14.6999Z",
    fill: "url(#paint10_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01722 17.1023C5.32391 17.1023 5.57253 16.8555 5.57253 16.5511C5.57253 16.2468 5.32391 16 5.01722 16C4.71053 16 4.46191 16.2468 4.46191 16.5511C4.46191 16.8555 4.71053 17.1023 5.01722 17.1023Z",
    fill: "url(#paint11_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3014 19.6218C4.60809 19.6218 4.85671 19.375 4.85671 19.0707C4.85671 18.7663 4.60809 18.5195 4.3014 18.5195C3.99471 18.5195 3.74609 18.7663 3.74609 19.0707C3.74609 19.375 3.99471 19.6218 4.3014 19.6218Z",
    fill: "url(#paint12_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94495 22.2155C4.25164 22.2155 4.50026 21.9688 4.50026 21.6644C4.50026 21.36 4.25164 21.1133 3.94495 21.1133C3.63827 21.1133 3.38965 21.36 3.38965 21.6644C3.38965 21.9688 3.63827 22.2155 3.94495 22.2155Z",
    fill: "url(#paint13_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94495 24.8327C4.25164 24.8327 4.50026 24.586 4.50026 24.2816C4.50026 23.9772 4.25164 23.7305 3.94495 23.7305C3.63827 23.7305 3.38965 23.9772 3.38965 24.2816C3.38965 24.586 3.63827 24.8327 3.94495 24.8327Z",
    fill: "url(#paint14_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3014 27.4265C4.60809 27.4265 4.85671 27.1797 4.85671 26.8754C4.85671 26.571 4.60809 26.3242 4.3014 26.3242C3.99471 26.3242 3.74609 26.571 3.74609 26.8754C3.74609 27.1797 3.99471 27.4265 4.3014 27.4265Z",
    fill: "url(#paint15_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01722 29.946C5.32391 29.946 5.57253 29.6993 5.57253 29.3949C5.57253 29.0905 5.32391 28.8438 5.01722 28.8438C4.71053 28.8438 4.46191 29.0905 4.46191 29.3949C4.46191 29.6993 4.71053 29.946 5.01722 29.946Z",
    fill: "url(#paint16_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06751 32.3484C6.3742 32.3484 6.62282 32.1016 6.62282 31.7972C6.62282 31.4928 6.3742 31.2461 6.06751 31.2461C5.76083 31.2461 5.51221 31.4928 5.51221 31.7972C5.51221 32.1016 5.76083 32.3484 6.06751 32.3484Z",
    fill: "url(#paint17_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43421 34.5945C7.7409 34.5945 7.98952 34.3477 7.98952 34.0433C7.98952 33.7389 7.7409 33.4922 7.43421 33.4922C7.12752 33.4922 6.87891 33.7389 6.87891 34.0433C6.87891 34.3477 7.12752 34.5945 7.43421 34.5945Z",
    fill: "url(#paint18_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10145 36.614C9.40814 36.614 9.65675 36.3672 9.65675 36.0629C9.65675 35.7585 9.40814 35.5117 9.10145 35.5117C8.79476 35.5117 8.54614 35.7585 8.54614 36.0629C8.54614 36.3672 8.79476 36.614 9.10145 36.614Z",
    fill: "url(#paint19_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0258 38.4226C11.3325 38.4226 11.5811 38.1758 11.5811 37.8714C11.5811 37.5671 11.3325 37.3203 11.0258 37.3203C10.7191 37.3203 10.4705 37.5671 10.4705 37.8714C10.4705 38.1758 10.7191 38.4226 11.0258 38.4226Z",
    fill: "url(#paint20_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1886 39.9187C13.4953 39.9187 13.7439 39.6719 13.7439 39.3675C13.7439 39.0632 13.4953 38.8164 13.1886 38.8164C12.8819 38.8164 12.6333 39.0632 12.6333 39.3675C12.6333 39.6719 12.8819 39.9187 13.1886 39.9187Z",
    fill: "url(#paint21_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5282 41.1296C15.8349 41.1296 16.0835 40.8829 16.0835 40.5785C16.0835 40.2741 15.8349 40.0273 15.5282 40.0273C15.2215 40.0273 14.9729 40.2741 14.9729 40.5785C14.9729 40.8829 15.2215 41.1296 15.5282 41.1296Z",
    fill: "url(#paint22_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0072 41.9968C18.3139 41.9968 18.5625 41.75 18.5625 41.4457C18.5625 41.1413 18.3139 40.8945 18.0072 40.8945C17.7005 40.8945 17.4519 41.1413 17.4519 41.4457C17.4519 41.75 17.7005 41.9968 18.0072 41.9968Z",
    fill: "url(#paint23_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6041 42.5554C20.9108 42.5554 21.1594 42.3086 21.1594 42.0043C21.1594 41.6999 20.9108 41.4531 20.6041 41.4531C20.2974 41.4531 20.0488 41.6999 20.0488 42.0043C20.0488 42.3086 20.2974 42.5554 20.6041 42.5554Z",
    fill: "url(#paint24_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2411 42.7273C23.5478 42.7273 23.7964 42.4805 23.7964 42.1761C23.7964 41.8717 23.5478 41.625 23.2411 41.625C22.9344 41.625 22.6858 41.8717 22.6858 42.1761C22.6858 42.4805 22.9344 42.7273 23.2411 42.7273Z",
    fill: "url(#paint25_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8597 42.5554C26.1664 42.5554 26.4151 42.3086 26.4151 42.0043C26.4151 41.6999 26.1664 41.4531 25.8597 41.4531C25.5531 41.4531 25.3044 41.6999 25.3044 42.0043C25.3044 42.3086 25.5531 42.5554 25.8597 42.5554Z",
    fill: "url(#paint26_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4564 41.9968C28.7631 41.9968 29.0117 41.75 29.0117 41.4457C29.0117 41.1413 28.7631 40.8945 28.4564 40.8945C28.1497 40.8945 27.9011 41.1413 27.9011 41.4457C27.9011 41.75 28.1497 41.9968 28.4564 41.9968Z",
    fill: "url(#paint27_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9354 41.1296C31.2421 41.1296 31.4907 40.8829 31.4907 40.5785C31.4907 40.2741 31.2421 40.0273 30.9354 40.0273C30.6287 40.0273 30.3801 40.2741 30.3801 40.5785C30.3801 40.8829 30.6287 41.1296 30.9354 41.1296Z",
    fill: "url(#paint28_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2782 39.9187C33.5849 39.9187 33.8335 39.6719 33.8335 39.3675C33.8335 39.0632 33.5849 38.8164 33.2782 38.8164C32.9715 38.8164 32.7229 39.0632 32.7229 39.3675C32.7229 39.6719 32.9715 39.9187 33.2782 39.9187Z",
    fill: "url(#paint29_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4381 38.4226C35.7448 38.4226 35.9934 38.1758 35.9934 37.8714C35.9934 37.5671 35.7448 37.3203 35.4381 37.3203C35.1314 37.3203 34.8828 37.5671 34.8828 37.8714C34.8828 38.1758 35.1314 38.4226 35.4381 38.4226Z",
    fill: "url(#paint30_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3624 36.614C37.6691 36.614 37.9177 36.3672 37.9177 36.0629C37.9177 35.7585 37.6691 35.5117 37.3624 35.5117C37.0557 35.5117 36.8071 35.7585 36.8071 36.0629C36.8071 36.3672 37.0557 36.614 37.3624 36.614Z",
    fill: "url(#paint31_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0297 34.5945C39.3364 34.5945 39.585 34.3477 39.585 34.0433C39.585 33.7389 39.3364 33.4922 39.0297 33.4922C38.723 33.4922 38.4744 33.7389 38.4744 34.0433C38.4744 34.3477 38.723 34.5945 39.0297 34.5945Z",
    fill: "url(#paint32_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3961 32.3484C40.7028 32.3484 40.9514 32.1016 40.9514 31.7972C40.9514 31.4928 40.7028 31.2461 40.3961 31.2461C40.0894 31.2461 39.8408 31.4928 39.8408 31.7972C39.8408 32.1016 40.0894 32.3484 40.3961 32.3484Z",
    fill: "url(#paint33_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4498 29.946C41.7565 29.946 42.0051 29.6993 42.0051 29.3949C42.0051 29.0905 41.7565 28.8438 41.4498 28.8438C41.1432 28.8438 40.8945 29.0905 40.8945 29.3949C40.8945 29.6993 41.1432 29.946 41.4498 29.946Z",
    fill: "url(#paint34_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1625 27.4265C42.4692 27.4265 42.7178 27.1797 42.7178 26.8754C42.7178 26.571 42.4692 26.3242 42.1625 26.3242C41.8558 26.3242 41.6072 26.571 41.6072 26.8754C41.6072 27.1797 41.8558 27.4265 42.1625 27.4265Z",
    fill: "url(#paint35_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5189 24.8327C42.8256 24.8327 43.0742 24.586 43.0742 24.2816C43.0742 23.9772 42.8256 23.7305 42.5189 23.7305C42.2122 23.7305 41.9636 23.9772 41.9636 24.2816C41.9636 24.586 42.2122 24.8327 42.5189 24.8327Z",
    fill: "url(#paint36_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5189 22.2155C42.8256 22.2155 43.0742 21.9688 43.0742 21.6644C43.0742 21.36 42.8256 21.1133 42.5189 21.1133C42.2122 21.1133 41.9636 21.36 41.9636 21.6644C41.9636 21.9688 42.2122 22.2155 42.5189 22.2155Z",
    fill: "url(#paint37_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1625 19.6218C42.4692 19.6218 42.7178 19.375 42.7178 19.0707C42.7178 18.7663 42.4692 18.5195 42.1625 18.5195C41.8558 18.5195 41.6072 18.7663 41.6072 19.0707C41.6072 19.375 41.8558 19.6218 42.1625 19.6218Z",
    fill: "url(#paint38_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4498 17.1023C41.7565 17.1023 42.0051 16.8555 42.0051 16.5511C42.0051 16.2468 41.7565 16 41.4498 16C41.1432 16 40.8945 16.2468 40.8945 16.5511C40.8945 16.8555 41.1432 17.1023 41.4498 17.1023Z",
    fill: "url(#paint39_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3961 14.6999C40.7028 14.6999 40.9514 14.4532 40.9514 14.1488C40.9514 13.8444 40.7028 13.5977 40.3961 13.5977C40.0894 13.5977 39.8408 13.8444 39.8408 14.1488C39.8408 14.4532 40.0894 14.6999 40.3961 14.6999Z",
    fill: "url(#paint40_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0297 12.4538C39.3364 12.4538 39.585 12.2071 39.585 11.9027C39.585 11.5983 39.3364 11.3516 39.0297 11.3516C38.723 11.3516 38.4744 11.5983 38.4744 11.9027C38.4744 12.2071 38.723 12.4538 39.0297 12.4538Z",
    fill: "url(#paint41_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3624 10.4148C37.6691 10.4148 37.9177 10.168 37.9177 9.86363C37.9177 9.55925 37.6691 9.3125 37.3624 9.3125C37.0557 9.3125 36.8071 9.55925 36.8071 9.86363C36.8071 10.168 37.0557 10.4148 37.3624 10.4148Z",
    fill: "url(#paint42_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4381 8.62571C35.7448 8.62571 35.9934 8.37895 35.9934 8.07457C35.9934 7.77019 35.7448 7.52344 35.4381 7.52344C35.1314 7.52344 34.8828 7.77019 34.8828 8.07457C34.8828 8.37895 35.1314 8.62571 35.4381 8.62571Z",
    fill: "url(#paint43_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2782 7.10617C33.5849 7.10617 33.8335 6.85942 33.8335 6.55504C33.8335 6.25066 33.5849 6.00391 33.2782 6.00391C32.9715 6.00391 32.7229 6.25066 32.7229 6.55504C32.7229 6.85942 32.9715 7.10617 33.2782 7.10617Z",
    fill: "url(#paint44_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9354 5.91867C31.2421 5.91867 31.4907 5.67192 31.4907 5.36754C31.4907 5.06316 31.2421 4.81641 30.9354 4.81641C30.6287 4.81641 30.3801 5.06316 30.3801 5.36754C30.3801 5.67192 30.6287 5.91867 30.9354 5.91867Z",
    fill: "url(#paint45_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4379 5.05149C28.7446 5.05149 28.9932 4.80474 28.9932 4.50035C28.9932 4.19597 28.7446 3.94922 28.4379 3.94922C28.1312 3.94922 27.8826 4.19597 27.8826 4.50035C27.8826 4.80474 28.1312 5.05149 28.4379 5.05149Z",
    fill: "url(#paint46_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8597 4.49289C26.1664 4.49289 26.4151 4.24614 26.4151 3.94176C26.4151 3.63738 26.1664 3.39062 25.8597 3.39062C25.5531 3.39062 25.3044 3.63738 25.3044 3.94176C25.3044 4.24614 25.5531 4.49289 25.8597 4.49289Z",
    fill: "url(#paint47_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.495809 23.4685C0.769636 23.4685 0.991617 23.2482 0.991617 22.9765C0.991617 22.7047 0.769636 22.4844 0.495809 22.4844C0.221981 22.4844 0 22.7047 0 22.9765C0 23.2482 0.221981 23.4685 0.495809 23.4685Z",
    fill: "url(#paint48_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.635213 26.1014C0.90904 26.1014 1.13102 25.881 1.13102 25.6093C1.13102 25.3375 0.90904 25.1172 0.635213 25.1172C0.361385 25.1172 0.139404 25.3375 0.139404 25.6093C0.139404 25.881 0.361385 26.1014 0.635213 26.1014Z",
    fill: "url(#paint49_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09078 28.6795C1.36461 28.6795 1.58659 28.4592 1.58659 28.1874C1.58659 27.9156 1.36461 27.6953 1.09078 27.6953C0.816952 27.6953 0.594971 27.9156 0.594971 28.1874C0.594971 28.4592 0.816952 28.6795 1.09078 28.6795Z",
    fill: "url(#paint50_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86544 31.199C2.13926 31.199 2.36125 30.9787 2.36125 30.7069C2.36125 30.4352 2.13926 30.2148 1.86544 30.2148C1.59161 30.2148 1.36963 30.4352 1.36963 30.7069C1.36963 30.9787 1.59161 31.199 1.86544 31.199Z",
    fill: "url(#paint51_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89425 33.6014C3.16807 33.6014 3.39005 33.381 3.39005 33.1093C3.39005 32.8375 3.16807 32.6172 2.89425 32.6172C2.62042 32.6172 2.39844 32.8375 2.39844 33.1093C2.39844 33.381 2.62042 33.6014 2.89425 33.6014Z",
    fill: "url(#paint52_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22359 35.867C4.49742 35.867 4.7194 35.6467 4.7194 35.3749C4.7194 35.1031 4.49742 34.8828 4.22359 34.8828C3.94976 34.8828 3.72778 35.1031 3.72778 35.3749C3.72778 35.6467 3.94976 35.867 4.22359 35.867Z",
    fill: "url(#paint53_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81026 37.9646C6.08409 37.9646 6.30607 37.7443 6.30607 37.4726C6.30607 37.2008 6.08409 36.9805 5.81026 36.9805C5.53643 36.9805 5.31445 37.2008 5.31445 37.4726C5.31445 37.7443 5.53643 37.9646 5.81026 37.9646Z",
    fill: "url(#paint54_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6169 39.8631C7.89073 39.8631 8.11271 39.6428 8.11271 39.371C8.11271 39.0992 7.89073 38.8789 7.6169 38.8789C7.34307 38.8789 7.12109 39.0992 7.12109 39.371C7.12109 39.6428 7.34307 39.8631 7.6169 39.8631Z",
    fill: "url(#paint55_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63717 41.5779C9.91099 41.5779 10.133 41.3576 10.133 41.0858C10.133 40.8141 9.91099 40.5938 9.63717 40.5938C9.36334 40.5938 9.14136 40.8141 9.14136 41.0858C9.14136 41.3576 9.36334 41.5779 9.63717 41.5779Z",
    fill: "url(#paint56_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8591 42.9998C12.1329 42.9998 12.3549 42.7795 12.3549 42.5077C12.3549 42.2359 12.1329 42.0156 11.8591 42.0156C11.5853 42.0156 11.3633 42.2359 11.3633 42.5077C11.3633 42.7795 11.5853 42.9998 11.8591 42.9998Z",
    fill: "url(#paint57_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2204 44.1912C14.4942 44.1912 14.7162 43.9709 14.7162 43.6991C14.7162 43.4273 14.4942 43.207 14.2204 43.207C13.9466 43.207 13.7246 43.4273 13.7246 43.6991C13.7246 43.9709 13.9466 44.1912 14.2204 44.1912Z",
    fill: "url(#paint58_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 45.0935C16.9732 45.0935 17.1952 44.8732 17.1952 44.6015C17.1952 44.3297 16.9732 44.1094 16.6994 44.1094C16.4256 44.1094 16.2036 44.3297 16.2036 44.6015C16.2036 44.8732 16.4256 45.0935 16.6994 45.0935Z",
    fill: "url(#paint59_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2775 45.6912C19.5514 45.6912 19.7734 45.4709 19.7734 45.1991C19.7734 44.9273 19.5514 44.707 19.2775 44.707C19.0037 44.707 18.7817 44.9273 18.7817 45.1991C18.7817 45.4709 19.0037 45.6912 19.2775 45.6912Z",
    fill: "url(#paint60_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8962 45.9959C22.17 45.9959 22.392 45.7756 22.392 45.5038C22.392 45.232 22.17 45.0117 21.8962 45.0117C21.6224 45.0117 21.4004 45.232 21.4004 45.5038C21.4004 45.7756 21.6224 45.9959 21.8962 45.9959Z",
    fill: "url(#paint61_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 45.9959C24.807 45.9959 25.029 45.7756 25.029 45.5038C25.029 45.232 24.807 45.0117 24.5332 45.0117C24.2593 45.0117 24.0374 45.232 24.0374 45.5038C24.0374 45.7756 24.2593 45.9959 24.5332 45.9959Z",
    fill: "url(#paint62_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1704 45.6912C27.4442 45.6912 27.6662 45.4709 27.6662 45.1991C27.6662 44.9273 27.4442 44.707 27.1704 44.707C26.8965 44.707 26.6746 44.9273 26.6746 45.1991C26.6746 45.4709 26.8965 45.6912 27.1704 45.6912Z",
    fill: "url(#paint63_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7268 45.0935C30.0006 45.0935 30.2226 44.8732 30.2226 44.6015C30.2226 44.3297 30.0006 44.1094 29.7268 44.1094C29.4529 44.1094 29.231 44.3297 29.231 44.6015C29.231 44.8732 29.4529 45.0935 29.7268 45.0935Z",
    fill: "url(#paint64_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2275 44.1912C32.5013 44.1912 32.7233 43.9709 32.7233 43.6991C32.7233 43.4273 32.5013 43.207 32.2275 43.207C31.9537 43.207 31.7317 43.4273 31.7317 43.6991C31.7317 43.9709 31.9537 44.1912 32.2275 44.1912Z",
    fill: "url(#paint65_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5888 42.9998C34.8627 42.9998 35.0846 42.7795 35.0846 42.5077C35.0846 42.2359 34.8627 42.0156 34.5888 42.0156C34.315 42.0156 34.093 42.2359 34.093 42.5077C34.093 42.7795 34.315 42.9998 34.5888 42.9998Z",
    fill: "url(#paint66_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.789 41.5779C37.0628 41.5779 37.2848 41.3576 37.2848 41.0858C37.2848 40.8141 37.0628 40.5938 36.789 40.5938C36.5152 40.5938 36.2932 40.8141 36.2932 41.0858C36.2932 41.3576 36.5152 41.5779 36.789 41.5779Z",
    fill: "url(#paint67_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8125 39.8631C39.0863 39.8631 39.3083 39.6428 39.3083 39.371C39.3083 39.0992 39.0863 38.8789 38.8125 38.8789C38.5386 38.8789 38.3167 39.0992 38.3167 39.371C38.3167 39.6428 38.5386 39.8631 38.8125 39.8631Z",
    fill: "url(#paint68_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6377 37.9646C40.9115 37.9646 41.1335 37.7443 41.1335 37.4726C41.1335 37.2008 40.9115 36.9805 40.6377 36.9805C40.3638 36.9805 40.1418 37.2008 40.1418 37.4726C40.1418 37.7443 40.3638 37.9646 40.6377 37.9646Z",
    fill: "url(#paint69_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2026 35.867C42.4764 35.867 42.6984 35.6467 42.6984 35.3749C42.6984 35.1031 42.4764 34.8828 42.2026 34.8828C41.9288 34.8828 41.7068 35.1031 41.7068 35.3749C41.7068 35.6467 41.9288 35.867 42.2026 35.867Z",
    fill: "url(#paint70_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5319 33.6014C43.8058 33.6014 44.0278 33.381 44.0278 33.1093C44.0278 32.8375 43.8058 32.6172 43.5319 32.6172C43.2581 32.6172 43.0361 32.8375 43.0361 33.1093C43.0361 33.381 43.2581 33.6014 43.5319 33.6014Z",
    fill: "url(#paint71_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5825 31.199C44.8563 31.199 45.0783 30.9787 45.0783 30.7069C45.0783 30.4352 44.8563 30.2148 44.5825 30.2148C44.3087 30.2148 44.0867 30.4352 44.0867 30.7069C44.0867 30.9787 44.3087 31.199 44.5825 31.199Z",
    fill: "url(#paint72_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3354 28.6795C45.6092 28.6795 45.8312 28.4592 45.8312 28.1874C45.8312 27.9156 45.6092 27.6953 45.3354 27.6953C45.0616 27.6953 44.8396 27.9156 44.8396 28.1874C44.8396 28.4592 45.0616 28.6795 45.3354 28.6795Z",
    fill: "url(#paint73_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7941 26.1014C46.068 26.1014 46.29 25.881 46.29 25.6093C46.29 25.3375 46.068 25.1172 45.7941 25.1172C45.5203 25.1172 45.2983 25.3375 45.2983 25.6093C45.2983 25.881 45.5203 26.1014 45.7941 26.1014Z",
    fill: "url(#paint74_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9521 23.4685C46.2259 23.4685 46.4479 23.2482 46.4479 22.9765C46.4479 22.7047 46.2259 22.4844 45.9521 22.4844C45.6783 22.4844 45.4563 22.7047 45.4563 22.9765C45.4563 23.2482 45.6783 23.4685 45.9521 23.4685Z",
    fill: "url(#paint75_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7941 20.8553C46.068 20.8553 46.29 20.6349 46.29 20.3632C46.29 20.0914 46.068 19.8711 45.7941 19.8711C45.5203 19.8711 45.2983 20.0914 45.2983 20.3632C45.2983 20.6349 45.5203 20.8553 45.7941 20.8553Z",
    fill: "url(#paint76_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3354 18.2615C45.6092 18.2615 45.8312 18.0412 45.8312 17.7694C45.8312 17.4977 45.6092 17.2773 45.3354 17.2773C45.0616 17.2773 44.8396 17.4977 44.8396 17.7694C44.8396 18.0412 45.0616 18.2615 45.3354 18.2615Z",
    fill: "url(#paint77_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5825 15.7615C44.8563 15.7615 45.0783 15.5412 45.0783 15.2694C45.0783 14.9977 44.8563 14.7773 44.5825 14.7773C44.3087 14.7773 44.0867 14.9977 44.0867 15.2694C44.0867 15.5412 44.3087 15.7615 44.5825 15.7615Z",
    fill: "url(#paint78_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5319 13.3396C43.8058 13.3396 44.0278 13.1193 44.0278 12.8476C44.0278 12.5758 43.8058 12.3555 43.5319 12.3555C43.2581 12.3555 43.0361 12.5758 43.0361 12.8476C43.0361 13.1193 43.2581 13.3396 43.5319 13.3396Z",
    fill: "url(#paint79_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2026 11.074C42.4764 11.074 42.6984 10.8537 42.6984 10.5819C42.6984 10.3102 42.4764 10.0898 42.2026 10.0898C41.9288 10.0898 41.7068 10.3102 41.7068 10.5819C41.7068 10.8537 41.9288 11.074 42.2026 11.074Z",
    fill: "url(#paint80_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6377 8.97636C40.9115 8.97636 41.1335 8.75604 41.1335 8.48427C41.1335 8.2125 40.9115 7.99219 40.6377 7.99219C40.3638 7.99219 40.1418 8.2125 40.1418 8.48427C40.1418 8.75604 40.3638 8.97636 40.6377 8.97636Z",
    fill: "url(#paint81_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8125 7.05448C39.0863 7.05448 39.3083 6.83417 39.3083 6.5624C39.3083 6.29063 39.0863 6.07031 38.8125 6.07031C38.5386 6.07031 38.3167 6.29063 38.3167 6.5624C38.3167 6.83417 38.5386 7.05448 38.8125 7.05448Z",
    fill: "url(#paint82_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.789 5.36307C37.0628 5.36307 37.2848 5.14276 37.2848 4.87099C37.2848 4.59922 37.0628 4.37891 36.789 4.37891C36.5152 4.37891 36.2932 4.59922 36.2932 4.87099C36.2932 5.14276 36.5152 5.36307 36.789 5.36307Z",
    fill: "url(#paint83_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5888 3.9412C34.8627 3.9412 35.0846 3.72089 35.0846 3.44912C35.0846 3.17734 34.8627 2.95703 34.5888 2.95703C34.315 2.95703 34.093 3.17734 34.093 3.44912C34.093 3.72089 34.315 3.9412 34.5888 3.9412Z",
    fill: "url(#paint84_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2275 2.74589C32.5013 2.74589 32.7233 2.52557 32.7233 2.2538C32.7233 1.98203 32.5013 1.76172 32.2275 1.76172C31.9537 1.76172 31.7317 1.98203 31.7317 2.2538C31.7317 2.52557 31.9537 2.74589 32.2275 2.74589Z",
    fill: "url(#paint85_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7268 1.86307C30.0006 1.86307 30.2226 1.64276 30.2226 1.37099C30.2226 1.09922 30.0006 0.878906 29.7268 0.878906C29.4529 0.878906 29.231 1.09922 29.231 1.37099C29.231 1.64276 29.4529 1.86307 29.7268 1.86307Z",
    fill: "url(#paint86_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1704 1.24979C27.4442 1.24979 27.6662 1.02948 27.6662 0.757709C27.6662 0.485938 27.4442 0.265625 27.1704 0.265625C26.8965 0.265625 26.6746 0.485938 26.6746 0.757709C26.6746 1.02948 26.8965 1.24979 27.1704 1.24979Z",
    fill: "url(#paint87_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 0.96073C24.807 0.96073 25.029 0.740417 25.029 0.468646C25.029 0.196876 24.807 -0.0234375 24.5332 -0.0234375C24.2593 -0.0234375 24.0374 0.196876 24.0374 0.468646C24.0374 0.740417 24.2593 0.96073 24.5332 0.96073Z",
    fill: "url(#paint88_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8962 0.96073C22.17 0.96073 22.392 0.740417 22.392 0.468646C22.392 0.196876 22.17 -0.0234375 21.8962 -0.0234375C21.6224 -0.0234375 21.4004 0.196876 21.4004 0.468646C21.4004 0.740417 21.6224 0.96073 21.8962 0.96073Z",
    fill: "url(#paint89_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2775 1.24979C19.5514 1.24979 19.7734 1.02948 19.7734 0.757709C19.7734 0.485938 19.5514 0.265625 19.2775 0.265625C19.0037 0.265625 18.7817 0.485938 18.7817 0.757709C18.7817 1.02948 19.0037 1.24979 19.2775 1.24979Z",
    fill: "url(#paint90_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 1.86307C16.9732 1.86307 17.1952 1.64276 17.1952 1.37099C17.1952 1.09922 16.9732 0.878906 16.6994 0.878906C16.4256 0.878906 16.2036 1.09922 16.2036 1.37099C16.2036 1.64276 16.4256 1.86307 16.6994 1.86307Z",
    fill: "url(#paint91_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2204 2.74589C14.4942 2.74589 14.7162 2.52557 14.7162 2.2538C14.7162 1.98203 14.4942 1.76172 14.2204 1.76172C13.9466 1.76172 13.7246 1.98203 13.7246 2.2538C13.7246 2.52557 13.9466 2.74589 14.2204 2.74589Z",
    fill: "url(#paint92_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8591 3.9412C12.1329 3.9412 12.3549 3.72089 12.3549 3.44912C12.3549 3.17734 12.1329 2.95703 11.8591 2.95703C11.5853 2.95703 11.3633 3.17734 11.3633 3.44912C11.3633 3.72089 11.5853 3.9412 11.8591 3.9412Z",
    fill: "url(#paint93_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63717 5.36307C9.91099 5.36307 10.133 5.14276 10.133 4.87099C10.133 4.59922 9.91099 4.37891 9.63717 4.37891C9.36334 4.37891 9.14136 4.59922 9.14136 4.87099C9.14136 5.14276 9.36334 5.36307 9.63717 5.36307Z",
    fill: "url(#paint94_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6169 7.05448C7.89073 7.05448 8.11271 6.83417 8.11271 6.5624C8.11271 6.29063 7.89073 6.07031 7.6169 6.07031C7.34307 6.07031 7.12109 6.29063 7.12109 6.5624C7.12109 6.83417 7.34307 7.05448 7.6169 7.05448Z",
    fill: "url(#paint95_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81026 8.97636C6.08409 8.97636 6.30607 8.75604 6.30607 8.48427C6.30607 8.2125 6.08409 7.99219 5.81026 7.99219C5.53643 7.99219 5.31445 8.2125 5.31445 8.48427C5.31445 8.75604 5.53643 8.97636 5.81026 8.97636Z",
    fill: "url(#paint96_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22359 11.074C4.49742 11.074 4.7194 10.8537 4.7194 10.5819C4.7194 10.3102 4.49742 10.0898 4.22359 10.0898C3.94976 10.0898 3.72778 10.3102 3.72778 10.5819C3.72778 10.8537 3.94976 11.074 4.22359 11.074Z",
    fill: "url(#paint97_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91597 13.3396C3.1898 13.3396 3.41178 13.1193 3.41178 12.8476C3.41178 12.5758 3.1898 12.3555 2.91597 12.3555C2.64215 12.3555 2.42017 12.5758 2.42017 12.8476C2.42017 13.1193 2.64215 13.3396 2.91597 13.3396Z",
    fill: "url(#paint98_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.86544 15.7615C2.13926 15.7615 2.36125 15.5412 2.36125 15.2694C2.36125 14.9977 2.13926 14.7773 1.86544 14.7773C1.59161 14.7773 1.36963 14.9977 1.36963 15.2694C1.36963 15.5412 1.59161 15.7615 1.86544 15.7615Z",
    fill: "url(#paint99_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09078 18.2615C1.36461 18.2615 1.58659 18.0412 1.58659 17.7694C1.58659 17.4977 1.36461 17.2773 1.09078 17.2773C0.816952 17.2773 0.594971 17.4977 0.594971 17.7694C0.594971 18.0412 0.816952 18.2615 1.09078 18.2615Z",
    fill: "url(#paint100_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.635213 20.8553C0.90904 20.8553 1.13102 20.6349 1.13102 20.3632C1.13102 20.0914 0.90904 19.8711 0.635213 19.8711C0.361385 19.8711 0.139404 20.0914 0.139404 20.3632C0.139404 20.6349 0.361385 20.8553 0.635213 20.8553Z",
    fill: "url(#paint101_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 26.1849C7.82469 26.1849 8.09106 25.9205 8.09106 25.5944C8.09106 25.2683 7.82469 25.0039 7.49609 25.0039C7.1675 25.0039 6.90112 25.2683 6.90112 25.5944C6.90112 25.9205 7.1675 26.1849 7.49609 26.1849Z",
    fill: "url(#paint102_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1499 28.724C8.47849 28.724 8.74487 28.4596 8.74487 28.1335C8.74487 27.8073 8.47849 27.543 8.1499 27.543C7.82131 27.543 7.55493 27.8073 7.55493 28.1335C7.55493 28.4596 7.82131 28.724 8.1499 28.724Z",
    fill: "url(#paint103_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20337 31.1068C9.53196 31.1068 9.79834 30.8424 9.79834 30.5163C9.79834 30.1902 9.53196 29.9258 9.20337 29.9258C8.87478 29.9258 8.6084 30.1902 8.6084 30.5163C8.6084 30.8424 8.87478 31.1068 9.20337 31.1068Z",
    fill: "url(#paint104_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6506 33.2787C10.9792 33.2787 11.2456 33.0143 11.2456 32.6882C11.2456 32.362 10.9792 32.0977 10.6506 32.0977C10.322 32.0977 10.0557 32.362 10.0557 32.6882C10.0557 33.0143 10.322 33.2787 10.6506 33.2787Z",
    fill: "url(#paint105_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4355 35.2162C12.7641 35.2162 13.0305 34.9518 13.0305 34.6257C13.0305 34.2995 12.7641 34.0352 12.4355 34.0352C12.107 34.0352 11.8406 34.2995 11.8406 34.6257C11.8406 34.9518 12.107 35.2162 12.4355 35.2162Z",
    fill: "url(#paint106_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 36.7943C14.8247 36.7943 15.0911 36.5299 15.0911 36.2038C15.0911 35.8777 14.8247 35.6133 14.4961 35.6133C14.1675 35.6133 13.9011 35.8777 13.9011 36.2038C13.9011 36.5299 14.1675 36.7943 14.4961 36.7943Z",
    fill: "url(#paint107_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8171 38.0638C17.1457 38.0638 17.4121 37.7994 17.4121 37.4733C17.4121 37.1472 17.1457 36.8828 16.8171 36.8828C16.4885 36.8828 16.2222 37.1472 16.2222 37.4733C16.2222 37.7994 16.4885 38.0638 16.8171 38.0638Z",
    fill: "url(#paint108_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3179 38.9115C19.6465 38.9115 19.9128 38.6471 19.9128 38.321C19.9128 37.9948 19.6465 37.7305 19.3179 37.7305C18.9893 37.7305 18.7229 37.9948 18.7229 38.321C18.7229 38.6471 18.9893 38.9115 19.3179 38.9115Z",
    fill: "url(#paint109_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9148 39.349C22.2434 39.349 22.5098 39.0846 22.5098 38.7585C22.5098 38.4323 22.2434 38.168 21.9148 38.168C21.5862 38.168 21.3198 38.4323 21.3198 38.7585C21.3198 39.0846 21.5862 39.349 21.9148 39.349Z",
    fill: "url(#paint110_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 39.349C24.8618 39.349 25.1282 39.0846 25.1282 38.7585C25.1282 38.4323 24.8618 38.168 24.5332 38.168C24.2046 38.168 23.9382 38.4323 23.9382 38.7585C23.9382 39.0846 24.2046 39.349 24.5332 39.349Z",
    fill: "url(#paint111_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1301 38.9115C27.4587 38.9115 27.7251 38.6471 27.7251 38.321C27.7251 37.9948 27.4587 37.7305 27.1301 37.7305C26.8015 37.7305 26.5352 37.9948 26.5352 38.321C26.5352 38.6471 26.8015 38.9115 27.1301 38.9115Z",
    fill: "url(#paint112_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6277 38.0638C29.9563 38.0638 30.2227 37.7994 30.2227 37.4733C30.2227 37.1472 29.9563 36.8828 29.6277 36.8828C29.2991 36.8828 29.0327 37.1472 29.0327 37.4733C29.0327 37.7994 29.2991 38.0638 29.6277 38.0638Z",
    fill: "url(#paint113_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9487 36.7943C32.2773 36.7943 32.5437 36.5299 32.5437 36.2038C32.5437 35.8777 32.2773 35.6133 31.9487 35.6133C31.6201 35.6133 31.3538 35.8777 31.3538 36.2038C31.3538 36.5299 31.6201 36.7943 31.9487 36.7943Z",
    fill: "url(#paint114_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0125 35.2162C34.341 35.2162 34.6074 34.9518 34.6074 34.6257C34.6074 34.2995 34.341 34.0352 34.0125 34.0352C33.6839 34.0352 33.4175 34.2995 33.4175 34.6257C33.4175 34.9518 33.6839 35.2162 34.0125 35.2162Z",
    fill: "url(#paint115_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7974 33.2787C36.126 33.2787 36.3923 33.0143 36.3923 32.6882C36.3923 32.362 36.126 32.0977 35.7974 32.0977C35.4688 32.0977 35.2024 32.362 35.2024 32.6882C35.2024 33.0143 35.4688 33.2787 35.7974 33.2787Z",
    fill: "url(#paint116_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2446 31.1068C37.5732 31.1068 37.8396 30.8424 37.8396 30.5163C37.8396 30.1902 37.5732 29.9258 37.2446 29.9258C36.916 29.9258 36.6497 30.1902 36.6497 30.5163C36.6497 30.8424 36.916 31.1068 37.2446 31.1068Z",
    fill: "url(#paint117_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2949 28.7044C38.6235 28.7044 38.8899 28.4401 38.8899 28.1139C38.8899 27.7878 38.6235 27.5234 38.2949 27.5234C37.9663 27.5234 37.7 27.7878 37.7 28.1139C37.7 28.4401 37.9663 28.7044 38.2949 28.7044Z",
    fill: "url(#paint118_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9519 26.1849C39.2805 26.1849 39.5469 25.9205 39.5469 25.5944C39.5469 25.2683 39.2805 25.0039 38.9519 25.0039C38.6233 25.0039 38.3569 25.2683 38.3569 25.5944C38.3569 25.9205 38.6233 26.1849 38.9519 26.1849Z",
    fill: "url(#paint119_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1689 23.5521C39.4975 23.5521 39.7639 23.2877 39.7639 22.9616C39.7639 22.6355 39.4975 22.3711 39.1689 22.3711C38.8404 22.3711 38.574 22.6355 38.574 22.9616C38.574 23.2877 38.8404 23.5521 39.1689 23.5521Z",
    fill: "url(#paint120_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.949 20.9583C39.2776 20.9583 39.5439 20.694 39.5439 20.3678C39.5439 20.0417 39.2776 19.7773 38.949 19.7773C38.6204 19.7773 38.354 20.0417 38.354 20.3678C38.354 20.694 38.6204 20.9583 38.949 20.9583Z",
    fill: "url(#paint121_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2949 18.4193C38.6235 18.4193 38.8899 18.1549 38.8899 17.8288C38.8899 17.5027 38.6235 17.2383 38.2949 17.2383C37.9663 17.2383 37.7 17.5027 37.7 17.8288C37.7 18.1549 37.9663 18.4193 38.2949 18.4193Z",
    fill: "url(#paint122_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2446 16.0365C37.5732 16.0365 37.8396 15.7721 37.8396 15.446C37.8396 15.1198 37.5732 14.8555 37.2446 14.8555C36.916 14.8555 36.6497 15.1198 36.6497 15.446C36.6497 15.7721 36.916 16.0365 37.2446 16.0365Z",
    fill: "url(#paint123_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7974 13.8451C36.126 13.8451 36.3923 13.5807 36.3923 13.2546C36.3923 12.9284 36.126 12.6641 35.7974 12.6641C35.4688 12.6641 35.2024 12.9284 35.2024 13.2546C35.2024 13.5807 35.4688 13.8451 35.7974 13.8451Z",
    fill: "url(#paint124_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0125 11.9232C34.341 11.9232 34.6074 11.6588 34.6074 11.3327C34.6074 11.0066 34.341 10.7422 34.0125 10.7422C33.6839 10.7422 33.4175 11.0066 33.4175 11.3327C33.4175 11.6588 33.6839 11.9232 34.0125 11.9232Z",
    fill: "url(#paint125_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9302 10.3255C32.2588 10.3255 32.5251 10.0612 32.5251 9.73503C32.5251 9.40891 32.2588 9.14453 31.9302 9.14453C31.6016 9.14453 31.3352 9.40891 31.3352 9.73503C31.3352 10.0612 31.6016 10.3255 31.9302 10.3255Z",
    fill: "url(#paint126_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6309 9.07553C29.9595 9.07553 30.2258 8.81116 30.2258 8.48503C30.2258 8.15891 29.9595 7.89453 29.6309 7.89453C29.3023 7.89453 29.0359 8.15891 29.0359 8.48503C29.0359 8.81116 29.3023 9.07553 29.6309 9.07553Z",
    fill: "url(#paint127_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1301 8.23178C27.4587 8.23178 27.7251 7.96741 27.7251 7.64128C27.7251 7.31516 27.4587 7.05078 27.1301 7.05078C26.8015 7.05078 26.5352 7.31516 26.5352 7.64128C26.5352 7.96741 26.8015 8.23178 27.1301 8.23178Z",
    fill: "url(#paint128_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 7.78647C24.8618 7.78647 25.1282 7.52209 25.1282 7.19597C25.1282 6.86984 24.8618 6.60547 24.5332 6.60547C24.2046 6.60547 23.9382 6.86984 23.9382 7.19597C23.9382 7.52209 24.2046 7.78647 24.5332 7.78647Z",
    fill: "url(#paint129_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8931 7.80991C22.2217 7.80991 22.488 7.54553 22.488 7.21941C22.488 6.89328 22.2217 6.62891 21.8931 6.62891C21.5645 6.62891 21.2981 6.89328 21.2981 7.21941C21.2981 7.54553 21.5645 7.80991 21.8931 7.80991Z",
    fill: "url(#paint130_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2961 8.23178C19.6247 8.23178 19.8911 7.96741 19.8911 7.64128C19.8911 7.31516 19.6247 7.05078 19.2961 7.05078C18.9675 7.05078 18.7012 7.31516 18.7012 7.64128C18.7012 7.96741 18.9675 8.23178 19.2961 8.23178Z",
    fill: "url(#paint131_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8171 9.09506C17.1457 9.09506 17.4121 8.83069 17.4121 8.50456C17.4121 8.17844 17.1457 7.91406 16.8171 7.91406C16.4885 7.91406 16.2222 8.17844 16.2222 8.50456C16.2222 8.83069 16.4885 9.09506 16.8171 9.09506Z",
    fill: "url(#paint132_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 10.3255C14.8247 10.3255 15.0911 10.0612 15.0911 9.73503C15.0911 9.40891 14.8247 9.14453 14.4961 9.14453C14.1675 9.14453 13.9011 9.40891 13.9011 9.73503C13.9011 10.0612 14.1675 10.3255 14.4961 10.3255Z",
    fill: "url(#paint133_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4138 11.9232C12.7424 11.9232 13.0088 11.6588 13.0088 11.3327C13.0088 11.0066 12.7424 10.7422 12.4138 10.7422C12.0852 10.7422 11.8188 11.0066 11.8188 11.3327C11.8188 11.6588 12.0852 11.9232 12.4138 11.9232Z",
    fill: "url(#paint134_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6289 13.8451C10.9575 13.8451 11.2239 13.5807 11.2239 13.2546C11.2239 12.9284 10.9575 12.6641 10.6289 12.6641C10.3003 12.6641 10.0339 12.9284 10.0339 13.2546C10.0339 13.5807 10.3003 13.8451 10.6289 13.8451Z",
    fill: "url(#paint135_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20044 16.0365C9.52903 16.0365 9.79541 15.7721 9.79541 15.446C9.79541 15.1198 9.52903 14.8555 9.20044 14.8555C8.87185 14.8555 8.60547 15.1198 8.60547 15.446C8.60547 15.7721 8.87185 16.0365 9.20044 16.0365Z",
    fill: "url(#paint136_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1499 18.4388C8.47849 18.4388 8.74487 18.1744 8.74487 17.8483C8.74487 17.5222 8.47849 17.2578 8.1499 17.2578C7.82131 17.2578 7.55493 17.5222 7.55493 17.8483C7.55493 18.1744 7.82131 18.4388 8.1499 18.4388Z",
    fill: "url(#paint137_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 20.9583C7.82469 20.9583 8.09106 20.694 8.09106 20.3678C8.09106 20.0417 7.82469 19.7773 7.49609 19.7773C7.1675 19.7773 6.90112 20.0417 6.90112 20.3678C6.90112 20.694 7.1675 20.9583 7.49609 20.9583Z",
    fill: "url(#paint138_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2267 11.0804C23.5882 11.0804 23.8812 10.7895 23.8812 10.4308C23.8812 10.0721 23.5882 9.78125 23.2267 9.78125C22.8653 9.78125 22.5723 10.0721 22.5723 10.4308C22.5723 10.7895 22.8653 11.0804 23.2267 11.0804Z",
    fill: "url(#paint139_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6083 11.346C20.9698 11.346 21.2628 11.0552 21.2628 10.6964C21.2628 10.3377 20.9698 10.0469 20.6083 10.0469C20.2469 10.0469 19.9539 10.3377 19.9539 10.6964C19.9539 11.0552 20.2469 11.346 20.6083 11.346Z",
    fill: "url(#paint140_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0888 12.1585C18.4502 12.1585 18.7433 11.8677 18.7433 11.5089C18.7433 11.1502 18.4502 10.8594 18.0888 10.8594C17.7273 10.8594 17.4343 11.1502 17.4343 11.5089C17.4343 11.8677 17.7273 12.1585 18.0888 12.1585Z",
    fill: "url(#paint141_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8083 13.4632C16.1697 13.4632 16.4627 13.1723 16.4627 12.8136C16.4627 12.4549 16.1697 12.1641 15.8083 12.1641C15.4468 12.1641 15.1538 12.4549 15.1538 12.8136C15.1538 13.1723 15.4468 13.4632 15.8083 13.4632Z",
    fill: "url(#paint142_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8434 15.2132C14.2049 15.2132 14.4979 14.9223 14.4979 14.5636C14.4979 14.2049 14.2049 13.9141 13.8434 13.9141C13.482 13.9141 13.189 14.2049 13.189 14.5636C13.189 14.9223 13.482 15.2132 13.8434 15.2132Z",
    fill: "url(#paint143_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2787 17.346C12.6402 17.346 12.9332 17.0552 12.9332 16.6964C12.9332 16.3377 12.6402 16.0469 12.2787 16.0469C11.9173 16.0469 11.6243 16.3377 11.6243 16.6964C11.6243 17.0552 11.9173 17.346 12.2787 17.346Z",
    fill: "url(#paint144_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2065 19.7483C11.5679 19.7483 11.8609 19.4575 11.8609 19.0988C11.8609 18.74 11.5679 18.4492 11.2065 18.4492C10.845 18.4492 10.552 18.74 10.552 19.0988C10.552 19.4575 10.845 19.7483 11.2065 19.7483Z",
    fill: "url(#paint145_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6518 22.3069C11.0132 22.3069 11.3062 22.0161 11.3062 21.6574C11.3062 21.2986 11.0132 21.0078 10.6518 21.0078C10.2903 21.0078 9.99731 21.2986 9.99731 21.6574C9.99731 22.0161 10.2903 22.3069 10.6518 22.3069Z",
    fill: "url(#paint146_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6518 24.9202C11.0132 24.9202 11.3062 24.6294 11.3062 24.2706C11.3062 23.9119 11.0132 23.6211 10.6518 23.6211C10.2903 23.6211 9.99731 23.9119 9.99731 24.2706C9.99731 24.6294 10.2903 24.9202 10.6518 24.9202Z",
    fill: "url(#paint147_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2065 27.4749C11.5679 27.4749 11.8609 27.1841 11.8609 26.8253C11.8609 26.4666 11.5679 26.1758 11.2065 26.1758C10.845 26.1758 10.552 26.4666 10.552 26.8253C10.552 27.1841 10.845 27.4749 11.2065 27.4749Z",
    fill: "url(#paint148_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2787 29.8811C12.6402 29.8811 12.9332 29.5903 12.9332 29.2316C12.9332 28.8728 12.6402 28.582 12.2787 28.582C11.9173 28.582 11.6243 28.8728 11.6243 29.2316C11.6243 29.5903 11.9173 29.8811 12.2787 29.8811Z",
    fill: "url(#paint149_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8249 32.0139C14.1863 32.0139 14.4793 31.7231 14.4793 31.3644C14.4793 31.0057 14.1863 30.7148 13.8249 30.7148C13.4634 30.7148 13.1704 31.0057 13.1704 31.3644C13.1704 31.7231 13.4634 32.0139 13.8249 32.0139Z",
    fill: "url(#paint150_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7895 33.76C16.1509 33.76 16.4439 33.4692 16.4439 33.1105C16.4439 32.7518 16.1509 32.4609 15.7895 32.4609C15.428 32.4609 15.135 32.7518 15.135 33.1105C15.135 33.4692 15.428 33.76 15.7895 33.76Z",
    fill: "url(#paint151_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0702 35.0686C18.4317 35.0686 18.7247 34.7778 18.7247 34.4191C18.7247 34.0603 18.4317 33.7695 18.0702 33.7695C17.7088 33.7695 17.4158 34.0603 17.4158 34.4191C17.4158 34.7778 17.7088 35.0686 18.0702 35.0686Z",
    fill: "url(#paint152_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5866 35.8772C20.948 35.8772 21.2411 35.5864 21.2411 35.2277C21.2411 34.8689 20.948 34.5781 20.5866 34.5781C20.2251 34.5781 19.9321 34.8689 19.9321 35.2277C19.9321 35.5864 20.2251 35.8772 20.5866 35.8772Z",
    fill: "url(#paint153_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.205 36.1663C23.5665 36.1663 23.8595 35.8755 23.8595 35.5167C23.8595 35.158 23.5665 34.8672 23.205 34.8672C22.8436 34.8672 22.5505 35.158 22.5505 35.5167C22.5505 35.8755 22.8436 36.1663 23.205 36.1663Z",
    fill: "url(#paint154_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8422 35.8772C26.2037 35.8772 26.4967 35.5864 26.4967 35.2277C26.4967 34.8689 26.2037 34.5781 25.8422 34.5781C25.4808 34.5781 25.1877 34.8689 25.1877 35.2277C25.1877 35.5864 25.4808 35.8772 25.8422 35.8772Z",
    fill: "url(#paint155_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3615 35.0686C28.723 35.0686 29.016 34.7778 29.016 34.4191C29.016 34.0603 28.723 33.7695 28.3615 33.7695C28 33.7695 27.707 34.0603 27.707 34.4191C27.707 34.7778 28 35.0686 28.3615 35.0686Z",
    fill: "url(#paint156_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6423 33.7796C31.0037 33.7796 31.2967 33.4888 31.2967 33.13C31.2967 32.7713 31.0037 32.4805 30.6423 32.4805C30.2808 32.4805 29.9878 32.7713 29.9878 33.13C29.9878 33.4888 30.2808 33.7796 30.6423 33.7796Z",
    fill: "url(#paint157_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6069 32.0335C32.9683 32.0335 33.2613 31.7427 33.2613 31.3839C33.2613 31.0252 32.9683 30.7344 32.6069 30.7344C32.2454 30.7344 31.9524 31.0252 31.9524 31.3839C31.9524 31.7427 32.2454 32.0335 32.6069 32.0335Z",
    fill: "url(#paint158_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.153 29.8968C34.5145 29.8968 34.8075 29.6059 34.8075 29.2472C34.8075 28.8885 34.5145 28.5977 34.153 28.5977C33.7916 28.5977 33.4985 28.8885 33.4985 29.2472C33.4985 29.6059 33.7916 29.8968 34.153 29.8968Z",
    fill: "url(#paint159_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2438 27.4983C35.6053 27.4983 35.8983 27.2075 35.8983 26.8488C35.8983 26.49 35.6053 26.1992 35.2438 26.1992C34.8824 26.1992 34.5894 26.49 34.5894 26.8488C34.5894 27.2075 34.8824 27.4983 35.2438 27.4983Z",
    fill: "url(#paint160_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.78 24.9397C36.1414 24.9397 36.4344 24.6489 36.4344 24.2902C36.4344 23.9314 36.1414 23.6406 35.78 23.6406C35.4185 23.6406 35.1255 23.9314 35.1255 24.2902C35.1255 24.6489 35.4185 24.9397 35.78 24.9397Z",
    fill: "url(#paint161_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.78 22.3264C36.1414 22.3264 36.4344 22.0356 36.4344 21.6769C36.4344 21.3182 36.1414 21.0273 35.78 21.0273C35.4185 21.0273 35.1255 21.3182 35.1255 21.6769C35.1255 22.0356 35.4185 22.3264 35.78 22.3264Z",
    fill: "url(#paint162_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2438 19.7483C35.6053 19.7483 35.8983 19.4575 35.8983 19.0988C35.8983 18.74 35.6053 18.4492 35.2438 18.4492C34.8824 18.4492 34.5894 18.74 34.5894 19.0988C34.5894 19.4575 34.8824 19.7483 35.2438 19.7483Z",
    fill: "url(#paint163_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1718 17.3655C34.5333 17.3655 34.8263 17.0747 34.8263 16.716C34.8263 16.3572 34.5333 16.0664 34.1718 16.0664C33.8103 16.0664 33.5173 16.3572 33.5173 16.716C33.5173 17.0747 33.8103 17.3655 34.1718 17.3655Z",
    fill: "url(#paint164_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6254 15.2327C32.9869 15.2327 33.2799 14.9419 33.2799 14.5831C33.2799 14.2244 32.9869 13.9336 32.6254 13.9336C32.264 13.9336 31.9709 14.2244 31.9709 14.5831C31.9709 14.9419 32.264 15.2327 32.6254 15.2327Z",
    fill: "url(#paint165_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6637 13.4827C31.0252 13.4827 31.3182 13.1919 31.3182 12.8331C31.3182 12.4744 31.0252 12.1836 30.6637 12.1836C30.3023 12.1836 30.0093 12.4744 30.0093 12.8331C30.0093 13.1919 30.3023 13.4827 30.6637 13.4827Z",
    fill: "url(#paint166_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3615 12.1585C28.723 12.1585 29.016 11.8677 29.016 11.5089C29.016 11.1502 28.723 10.8594 28.3615 10.8594C28 10.8594 27.707 11.1502 27.707 11.5089C27.707 11.8677 28 12.1585 28.3615 12.1585Z",
    fill: "url(#paint167_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8637 11.346C26.2251 11.346 26.5182 11.0552 26.5182 10.6964C26.5182 10.3377 26.2251 10.0469 25.8637 10.0469C25.5022 10.0469 25.2092 10.3377 25.2092 10.6964C25.2092 11.0552 25.5022 11.346 25.8637 11.346Z",
    fill: "url(#paint168_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.397 26.2294C14.7804 26.2294 15.0911 25.921 15.0911 25.5405C15.0911 25.16 14.7804 24.8516 14.397 24.8516C14.0137 24.8516 13.7029 25.16 13.7029 25.5405C13.7029 25.921 14.0137 26.2294 14.397 26.2294Z",
    fill: "url(#paint169_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4878 28.6122C15.8712 28.6122 16.182 28.3038 16.182 27.9233C16.182 27.5428 15.8712 27.2344 15.4878 27.2344C15.1045 27.2344 14.7937 27.5428 14.7937 27.9233C14.7937 28.3038 15.1045 28.6122 15.4878 28.6122Z",
    fill: "url(#paint170_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1954 30.5927C17.5787 30.5927 17.8895 30.2842 17.8895 29.9038C17.8895 29.5233 17.5787 29.2148 17.1954 29.2148C16.812 29.2148 16.5012 29.5233 16.5012 29.9038C16.5012 30.2842 16.812 30.5927 17.1954 30.5927Z",
    fill: "url(#paint171_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3953 31.9755C19.7787 31.9755 20.0894 31.6671 20.0894 31.2866C20.0894 30.9061 19.7787 30.5977 19.3953 30.5977C19.0119 30.5977 18.7012 30.9061 18.7012 31.2866C18.7012 31.6671 19.0119 31.9755 19.3953 31.9755Z",
    fill: "url(#paint172_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9148 32.706C22.2982 32.706 22.609 32.3975 22.609 32.017C22.609 31.6366 22.2982 31.3281 21.9148 31.3281C21.5315 31.3281 21.2207 31.6366 21.2207 32.017C21.2207 32.3975 21.5315 32.706 21.9148 32.706Z",
    fill: "url(#paint173_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 32.706C24.9166 32.706 25.2274 32.3975 25.2274 32.017C25.2274 31.6366 24.9166 31.3281 24.5332 31.3281C24.1499 31.3281 23.8391 31.6366 23.8391 32.017C23.8391 32.3975 24.1499 32.706 24.5332 32.706Z",
    fill: "url(#paint174_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0525 31.9755C27.4359 31.9755 27.7467 31.6671 27.7467 31.2866C27.7467 30.9061 27.4359 30.5977 27.0525 30.5977C26.6692 30.5977 26.3584 30.9061 26.3584 31.2866C26.3584 31.6671 26.6692 31.9755 27.0525 31.9755Z",
    fill: "url(#paint175_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2527 30.5927C29.6361 30.5927 29.9469 30.2842 29.9469 29.9038C29.9469 29.5233 29.6361 29.2148 29.2527 29.2148C28.8694 29.2148 28.5586 29.5233 28.5586 29.9038C28.5586 30.2842 28.8694 30.5927 29.2527 30.5927Z",
    fill: "url(#paint176_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9788 28.6122C31.3622 28.6122 31.6729 28.3038 31.6729 27.9233C31.6729 27.5428 31.3622 27.2344 30.9788 27.2344C30.5954 27.2344 30.2847 27.5428 30.2847 27.9233C30.2847 28.3038 30.5954 28.6122 30.9788 28.6122Z",
    fill: "url(#paint177_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0696 26.245C32.453 26.245 32.7638 25.9366 32.7638 25.5561C32.7638 25.1756 32.453 24.8672 32.0696 24.8672C31.6863 24.8672 31.3755 25.1756 31.3755 25.5561C31.3755 25.9366 31.6863 26.245 32.0696 26.245Z",
    fill: "url(#paint178_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4444 23.6708C32.8277 23.6708 33.1385 23.3624 33.1385 22.9819C33.1385 22.6014 32.8277 22.293 32.4444 22.293C32.061 22.293 31.7502 22.6014 31.7502 22.9819C31.7502 23.3624 32.061 23.6708 32.4444 23.6708Z",
    fill: "url(#paint179_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0696 21.0966C32.453 21.0966 32.7638 20.7881 32.7638 20.4077C32.7638 20.0272 32.453 19.7188 32.0696 19.7188C31.6863 19.7188 31.3755 20.0272 31.3755 20.4077C31.3755 20.7881 31.6863 21.0966 32.0696 21.0966Z",
    fill: "url(#paint180_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9788 18.7294C31.3622 18.7294 31.6729 18.421 31.6729 18.0405C31.6729 17.66 31.3622 17.3516 30.9788 17.3516C30.5954 17.3516 30.2847 17.66 30.2847 18.0405C30.2847 18.421 30.5954 18.7294 30.9788 18.7294Z",
    fill: "url(#paint181_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2527 16.7724C29.6361 16.7724 29.9469 16.4639 29.9469 16.0834C29.9469 15.703 29.6361 15.3945 29.2527 15.3945C28.8694 15.3945 28.5586 15.703 28.5586 16.0834C28.5586 16.4639 28.8694 16.7724 29.2527 16.7724Z",
    fill: "url(#paint182_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0525 15.3466C27.4359 15.3466 27.7467 15.0381 27.7467 14.6577C27.7467 14.2772 27.4359 13.9688 27.0525 13.9688C26.6692 13.9688 26.3584 14.2772 26.3584 14.6577C26.3584 15.0381 26.6692 15.3466 27.0525 15.3466Z",
    fill: "url(#paint183_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5518 14.62C24.9352 14.62 25.2459 14.3116 25.2459 13.9311C25.2459 13.5506 24.9352 13.2422 24.5518 13.2422C24.1684 13.2422 23.8577 13.5506 23.8577 13.9311C23.8577 14.3116 24.1684 14.62 24.5518 14.62Z",
    fill: "url(#paint184_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9148 14.62C22.2982 14.62 22.609 14.3116 22.609 13.9311C22.609 13.5506 22.2982 13.2422 21.9148 13.2422C21.5315 13.2422 21.2207 13.5506 21.2207 13.9311C21.2207 14.3116 21.5315 14.62 21.9148 14.62Z",
    fill: "url(#paint185_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.417 15.3466C19.8004 15.3466 20.1112 15.0381 20.1112 14.6577C20.1112 14.2772 19.8004 13.9688 19.417 13.9688C19.0337 13.9688 18.7229 14.2772 18.7229 14.6577C18.7229 15.0381 19.0337 15.3466 19.417 15.3466Z",
    fill: "url(#paint186_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1954 16.7724C17.5787 16.7724 17.8895 16.4639 17.8895 16.0834C17.8895 15.703 17.5787 15.3945 17.1954 15.3945C16.812 15.3945 16.5012 15.703 16.5012 16.0834C16.5012 16.4639 16.812 16.7724 17.1954 16.7724Z",
    fill: "url(#paint187_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4878 18.7294C15.8712 18.7294 16.182 18.421 16.182 18.0405C16.182 17.66 15.8712 17.3516 15.4878 17.3516C15.1045 17.3516 14.7937 17.66 14.7937 18.0405C14.7937 18.421 15.1045 18.7294 15.4878 18.7294Z",
    fill: "url(#paint188_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.397 21.0966C14.7804 21.0966 15.0911 20.7881 15.0911 20.4077C15.0911 20.0272 14.7804 19.7188 14.397 19.7188C14.0137 19.7188 13.7029 20.0272 13.7029 20.4077C13.7029 20.7881 14.0137 21.0966 14.397 21.0966Z",
    fill: "url(#paint189_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2231 17.9566C23.6283 17.9566 23.9569 17.6305 23.9569 17.2283C23.9569 16.8261 23.6283 16.5 23.2231 16.5C22.8178 16.5 22.4893 16.8261 22.4893 17.2283C22.4893 17.6305 22.8178 17.9566 23.2231 17.9566Z",
    fill: "url(#paint190_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7223 18.5347C21.1276 18.5347 21.4561 18.2086 21.4561 17.8064C21.4561 17.4042 21.1276 17.0781 20.7223 17.0781C20.3171 17.0781 19.9885 17.4042 19.9885 17.8064C19.9885 18.2086 20.3171 18.5347 20.7223 18.5347Z",
    fill: "url(#paint191_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7206 20.1284C19.1259 20.1284 19.4544 19.8024 19.4544 19.4002C19.4544 18.9979 19.1259 18.6719 18.7206 18.6719C18.3153 18.6719 17.9868 18.9979 17.9868 19.4002C17.9868 19.8024 18.3153 20.1284 18.7206 20.1284Z",
    fill: "url(#paint192_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5895 22.4175C17.9948 22.4175 18.3233 22.0914 18.3233 21.6892C18.3233 21.287 17.9948 20.9609 17.5895 20.9609C17.1842 20.9609 16.8557 21.287 16.8557 21.6892C16.8557 22.0914 17.1842 22.4175 17.5895 22.4175Z",
    fill: "url(#paint193_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5895 24.9761C17.9948 24.9761 18.3233 24.65 18.3233 24.2478C18.3233 23.8456 17.9948 23.5195 17.5895 23.5195C17.1842 23.5195 16.8557 23.8456 16.8557 24.2478C16.8557 24.65 17.1842 24.9761 17.5895 24.9761Z",
    fill: "url(#paint194_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7206 27.2613C19.1259 27.2613 19.4544 26.9352 19.4544 26.533C19.4544 26.1308 19.1259 25.8047 18.7206 25.8047C18.3153 25.8047 17.9868 26.1308 17.9868 26.533C17.9868 26.9352 18.3153 27.2613 18.7206 27.2613Z",
    fill: "url(#paint195_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7223 28.855C21.1276 28.855 21.4561 28.5289 21.4561 28.1267C21.4561 27.7245 21.1276 27.3984 20.7223 27.3984C20.3171 27.3984 19.9885 27.7245 19.9885 28.1267C19.9885 28.5289 20.3171 28.855 20.7223 28.855Z",
    fill: "url(#paint196_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2231 29.4331C23.6283 29.4331 23.9569 29.1071 23.9569 28.7048C23.9569 28.3026 23.6283 27.9766 23.2231 27.9766C22.8178 27.9766 22.4893 28.3026 22.4893 28.7048C22.4893 29.1071 22.8178 29.4331 23.2231 29.4331Z",
    fill: "url(#paint197_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7394 28.855C26.1447 28.855 26.4732 28.5289 26.4732 28.1267C26.4732 27.7245 26.1447 27.3984 25.7394 27.3984C25.3341 27.3984 25.0056 27.7245 25.0056 28.1267C25.0056 28.5289 25.3341 28.855 25.7394 28.855Z",
    fill: "url(#paint198_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7443 27.2613C28.1496 27.2613 28.4781 26.9352 28.4781 26.533C28.4781 26.1308 28.1496 25.8047 27.7443 25.8047C27.339 25.8047 27.0105 26.1308 27.0105 26.533C27.0105 26.9352 27.339 27.2613 27.7443 27.2613Z",
    fill: "url(#paint199_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8537 24.9761C29.2589 24.9761 29.5875 24.65 29.5875 24.2478C29.5875 23.8456 29.2589 23.5195 28.8537 23.5195C28.4484 23.5195 28.1199 23.8456 28.1199 24.2478C28.1199 24.65 28.4484 24.9761 28.8537 24.9761Z",
    fill: "url(#paint200_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8537 22.4175C29.2589 22.4175 29.5875 22.0914 29.5875 21.6892C29.5875 21.287 29.2589 20.9609 28.8537 20.9609C28.4484 20.9609 28.1199 21.287 28.1199 21.6892C28.1199 22.0914 28.4484 22.4175 28.8537 22.4175Z",
    fill: "url(#paint201_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7443 20.1284C28.1496 20.1284 28.4781 19.8024 28.4781 19.4002C28.4781 18.9979 28.1496 18.6719 27.7443 18.6719C27.339 18.6719 27.0105 18.9979 27.0105 19.4002C27.0105 19.8024 27.339 20.1284 27.7443 20.1284Z",
    fill: "url(#paint202_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7394 18.5347C26.1447 18.5347 26.4732 18.2086 26.4732 17.8064C26.4732 17.4042 26.1447 17.0781 25.7394 17.0781C25.3341 17.0781 25.0056 17.4042 25.0056 17.8064C25.0056 18.2086 25.3341 18.5347 25.7394 18.5347Z",
    fill: "url(#paint203_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0714 25.8559C22.5095 25.8559 22.8647 25.5034 22.8647 25.0686C22.8647 24.6338 22.5095 24.2812 22.0714 24.2812C21.6332 24.2812 21.2781 24.6338 21.2781 25.0686C21.2781 25.5034 21.6332 25.8559 22.0714 25.8559Z",
    fill: "url(#paint204_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8411 23.8364C21.2793 23.8364 21.6344 23.4839 21.6344 23.0491C21.6344 22.6142 21.2793 22.2617 20.8411 22.2617C20.403 22.2617 20.0479 22.6142 20.0479 23.0491C20.0479 23.4839 20.403 23.8364 20.8411 23.8364Z",
    fill: "url(#paint205_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4513 25.8169C24.8894 25.8169 25.2445 25.4644 25.2445 25.0295C25.2445 24.5947 24.8894 24.2422 24.4513 24.2422C24.0131 24.2422 23.658 24.5947 23.658 25.0295C23.658 25.4644 24.0131 25.8169 24.4513 25.8169Z",
    fill: "url(#paint206_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6009 23.7387C26.039 23.7387 26.3942 23.3862 26.3942 22.9514C26.3942 22.5166 26.039 22.1641 25.6009 22.1641C25.1628 22.1641 24.8076 22.5166 24.8076 22.9514C24.8076 23.3862 25.1628 23.7387 25.6009 23.7387Z",
    fill: "url(#paint207_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3924 21.7231C24.8305 21.7231 25.1857 21.3706 25.1857 20.9358C25.1857 20.5009 24.8305 20.1484 24.3924 20.1484C23.9543 20.1484 23.5991 20.5009 23.5991 20.9358C23.5991 21.3706 23.9543 21.7231 24.3924 21.7231Z",
    fill: "url(#paint208_radial_2733_8313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0125 21.7622C22.4507 21.7622 22.8058 21.4097 22.8058 20.9748C22.8058 20.54 22.4507 20.1875 22.0125 20.1875C21.5744 20.1875 21.2192 20.54 21.2192 20.9748C21.2192 21.4097 21.5744 21.7622 22.0125 21.7622Z",
    fill: "url(#paint209_radial_2733_8313)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0753 22.8714) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8707) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0737 22.8704) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0744 22.8689) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8726) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8737) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8605) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0738 22.8644) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.8623) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0719 22.874) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8762) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0744 22.8771) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0726 22.8772) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.8728) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.8721) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0726 22.8676) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0744 22.8677) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8686) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0719 22.8708) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.863) scale(50.6539 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0738 22.8804) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8608) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8711) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8722) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.8797) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0724 22.8744) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.8797) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0718 22.8722) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0718 22.8711) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8608) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0725 22.8804) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.863) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0744 22.8708) scale(50.6539 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0724 22.8686) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.075 22.8677) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0737 22.8676) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.8721) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.8728) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0737 22.8772) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.075 22.8771) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0724 22.8762) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0744 22.874) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.8623) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0725 22.8644) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8605) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0718 22.8737) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0731 22.8726) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0732 22.8651) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.866) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8809) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8805) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8806) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8816) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8836) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8752) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8643) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8864) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8714) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8818) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8787) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0753 22.8858) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8756) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0753 22.8756) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8858) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0729 22.8787) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0747 22.8818) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8714) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8864) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8643) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8752) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8836) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0747 22.8816) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8806) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8805) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8809) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.866) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8706) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8751) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8749) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0747 22.874) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.872) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8805) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8679) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8692) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8842) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0747 22.8699) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0729 22.8729) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8698) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0753 22.876) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.876) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0753 22.8698) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8729) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8699) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8842) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8692) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8679) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8805) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.872) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.874) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8749) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8751) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8706) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8858) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8857) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8868) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8738) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8823) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8661) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8759) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8772) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8817) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8817) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8772) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8759) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8661) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8823) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8738) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8868) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8858) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8858) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8708) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8753) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8754) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8743) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8677) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8748) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8715) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8812) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8839) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8716) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8753) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8839) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8811) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8715) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8748) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8677) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8743) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8752) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0743 22.8753) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0779 22.8783) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0773 22.8684) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0765 22.8739) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0767 22.8795) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0752 22.8776) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0773 22.8847) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8856) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0766 22.8854) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0766 22.8808) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8766) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0773 22.8815) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0765 22.8885) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0777 22.8828) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0778 22.8726) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8742) scale(50.6538 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8877) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8742) scale(50.6539 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8726) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0761 22.8827) scale(50.6539 50.2732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0773 22.8884) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0765 22.8775) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0765 22.8804) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0772 22.8806) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0772 22.8852) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0765 22.8856) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8845) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8775) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0777 22.8793) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8739) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0771 22.8684) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8712) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8723) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8845) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0741 22.8698) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.8719) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0754 22.8719) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8698) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8845) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8723) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8671) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8714) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8757) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8706) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0748 22.8819) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8733) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.875) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0749 22.875) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.076 22.8733) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0755 22.8819) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8706) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0735 22.8757) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8654) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0723 22.8727) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0737 22.8721) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8582) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.073 22.8776) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0737 22.8598) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0723 22.8592) scale(50.6538 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0742 22.8666) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0718 22.8592) scale(50.6539 50.2734)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8598) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0724 22.8776) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0724 22.8582) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0736 22.8721) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0718 22.8727) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0728 22.8914) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0721 22.8992) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0728 22.8917) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0721 22.8803) scale(50.6539 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8921) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_2733_8313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0734 22.8918) scale(50.6538 50.2733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0218257,
    stopColor: "#06FFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "#A165FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2733_8313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 46,
    fill: "white",
    transform: "translate(0 0.0195312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeotreeLogo);
export default __webpack_public_path__ + "static/media/geotree-logo.6aafd01c43d87dbadece917283a131ef.svg";
export { ForwardRef as ReactComponent };